import { render, staticRenderFns } from "./IconPopover.vue?vue&type=template&id=47005026&"
import script from "./IconPopover.vue?vue&type=script&lang=js&"
export * from "./IconPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports